const QUERY_KEYS = {
  // AUTH
  LOGIN_QUERY_KEY: "LOGIN_QUERY_KEY",
  GET_PROFILE_QUERY_KEY: "GET_PROFILE_QUERY_KEY",
  PROFILE_UPDATE_QUERY_KEY: "PROFILE_UPDATE_QUERY_KEY",
  CHANGE_PASSWORD_QUERY_KEY: "CHANGE_PASSWORD_QUERY_KEY",
  // AGRONOMISTS
  ADD_AGRONOMISTS_QUERY_KEY: "ADD_AGRONOMISTS_QUERY_KEY",
  AGRONOMISTS_LISTING_QUERY_KEY: "AGRONOMISTS_LISTING_QUERY_KEY",
  AGRONOMISTS_DETAIL_QUERY_KEY: "AGRONOMISTS_DETAIL_QUERY_KEY",
  AGRONOMISTS_EDIT_QUERY_KEY: "AGRONOMISTS_EDIT_QUERY_KEY",
  AGRONOMISTS_STATUS_QUERY_KEY: "AGRONOMISTS_STATUS_QUERY_KEY",
  AGRONOMISTS_DELETE_QUERY_KEY: "AGRONOMISTS_DELETE_QUERY_KEY",
  // PRODUCT
  ADD_PRODUCT_QUERY_KEY: "ADD_PRODUCT_QUERY_KEY",
  PRODUCT_LISTING_QUERY_KEY: "PRODUCT_LISTING_QUERY_KEY",
  PRODUCT_DETAIL_QUERY_KEY: "PRODUCT_DETAIL_QUERY_KEY",
  PRODUCT_EDIT_QUERY_KEY: "PRODUCT_EDIT_QUERY_KEY",
  PRODUCT_STATUS_QUERY_KEY: "PRODUCT_STATUS_QUERY_KEY",
  PRODUCT_DELETE_QUERY_KEY: "PRODUCT_DELETE_QUERY_KEY",
  // CONTAINER TYPE
  CONTAINER_TYPE_LIST_QUERY_KEY: "CONTAINER_TYPE_LIST_QUERY_KEY",
  ADD_CONTAINER_TYPE_QUERY_KEY: "ADD_CONTAINER_TYPE_QUERY_KEY",
  UPDATE_CONTAINER_TYPE_QUERY_KEY: "UPDATE_CONTAINER_TYPE_QUERY_KEY",
  DELETE_CONTAINER_TYPE_QUERY_KEY: "DELETE_CONTAINER_TYPE_QUERY_KEY",
  //CONTAINER UNIT
  CONTAINER_UNIT_LIST_QUERY_KEY: "CONTAINER_UNIT_LIST_QUERY_KEY",
  ADD_CONTAINER_UNIT_QUERY_KEY: "ADD_CONTAINER_UNIT_QUERY_KEY",
  UPDATE_CONTAINER_UNIT_QUERY_KEY: "UPDATE_CONTAINER_UNIT_QUERY_KEY",
  DELETE_CONTAINER_UNIT_QUERY_KEY: "DELETE_CONTAINER_UNIT_QUERY_KEY",
  // RATE UNIT
  RATE_UNIT_LIST_QUERY_KEY: "RATE_UNIT_LIST",
  ADD_RATE_UNIT_QUERY_KEY: "ADD_RATE_UNIT",
  UPDATE_RATE_UNIT_QUERY_KEY: "UPDATE_RATE_UNIT",
  DELETE_RATE_UNIT_QUERY_KEY: "DELETE_RATE_UNIT",
  // GROWER
  ADD_GROWER_QUERY_KEY: "ADD_GROWER_QUERY_KEY",
  GROWER_LISTING_QUERY_KEY: "GROWER_LISTING_QUERY_KEY",
  GROWER_DETAIL_QUERY_KEY: "GROWER_DETAIL_QUERY_KEY",
  GROWER_EDIT_QUERY_KEY: "GROWER_EDIT_QUERY_KEY",
  GROWER_STATUS_QUERY_KEY: "GROWER_STATUS_QUERY_KEY",
  GROWER_DELETE_QUERY_KEY: "GROWER_DELETE_QUERY_KEY",
  // CONTENT
  ADD_CONTENT_QUERY_KEY: "ADD_CONTENT_QUERY_KEY",
  CONTENT_GET_QUERY_KEY: "CONTENT_GET_QUERY_KEY",
  // CROP
  ADD_CROP_QUERY_KEY: "ADD_CROP_QUERY_KEY",
  CROP_LISTING_QUERY_KEY: "CROP_LISTING_QUERY_KEY",
  CROP_DETAIL_QUERY_KEY: "CROP_DETAIL_QUERY_KEY",
  CROP_EDIT_QUERY_KEY: "CROP_EDIT_QUERY_KEY",
  CROP_STATUS_QUERY_KEY: "CROP_STATUS_QUERY_KEY",
  CROP_DELETE_QUERY_KEY: "CROP_DELETE_QUERY_KEY",

  // SCOUTING
  SCOUTING_LIST_QUERY_KEY: "SCOUTING_LIST_QUERY_KEY",
  SCOUTING_DETAIL_QUERY_KEY: "SCOUTING_DETAIL_QUERY_KEY",

  // DASHBOARD
  DASHBOARD_QUERY_KEY: "DASHBOARD_QUERY_KEY",

  SEASON_YEARS_LIST_QUERY_KEY: "SEASON_YEARS_LIST_QUERY_KEY",
  CROP_PLANE_SEASON_LIST_QUERY_KEY: "CROP_PLANE_SEASON_LIST_QUERY_KEY",
  CROP_PLAN_DETAIL_QUERY_KEY: "CROP_PLAN_DETAIL_QUERY_KEY",
};

export default QUERY_KEYS;
